import React from 'react';
import autoBindReact from 'auto-bind/react';

export default class BaseComponent extends React.Component {
  constructor(...args) {
    super(...args);
    autoBindReact(this);
  }
}
